<template>
  <!-- home section start -->
  <section id="home" class="home-wrapper section-b-space overflow-hidden">
    <div class="background-effect">
      <div class="main-circle">
        <div class="main-circle circle-1">
          <div class="main-circle circle-2"></div>
        </div>
      </div>
    </div>
    <!-- <div class="container text-center position-relative">
      <br />
      <div class="row align-items-center">
        Left Side: Text
        <div class="col-6">
          <h1>{{ $t("axefood") }}</h1>
          <h2>{{ $t("Discover restaurants that deliver near you") }}</h2>
        </div>
      </div>
    </div> -->
  </section>
  <!-- home section end -->
</template>

<script setup></script>

<style></style>
